var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalP3Facebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7973 8H37.8154C34.7293 8 31.7695 9.24321 29.5873 11.4561C27.4051 13.6691 26.1791 16.6704 26.1791 19.8V26.88H19.1973V36.32H26.1791V55.2H35.4882V36.32H42.47L44.7973 26.88H35.4882V19.8C35.4882 19.1741 35.7334 18.5738 36.1698 18.1312C36.6063 17.6886 37.1982 17.44 37.8154 17.44H44.7973V8Z",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalP3Facebook);
export default __webpack_public_path__ + "static/media/Digital_P3_Facebook.8941ec3f113a953f702e851d21e39af3.svg";
export { ForwardRef as ReactComponent };